export const serverApi: string = `${process.env.REACT_APP_API_URL}`;

export const Messages = {
    error1: "Something went wrong!",
    error2: "Please login first!",
    error3: "Please fulfil all the required fields!",
    error4: "Message is empty!",
    error5: "Only images in jpeg, jpg, png formats are allowed!",
};